function ProductQtySet() {

}

// 点击INPUT框 +号时的函数 增加商品1
ProductQtySet.prototype.listenAddEvent = function () {
    var submitBtn = $('.inc');
    submitBtn.click(function () {
        var count = $(this).siblings('input').val();
        count = parseInt(count) + 1;
        if(count>10){
            count = 10;
        }
        $(this).siblings('input').val(count);
    })
}

// 点击INPUT框 -号时的函数 减少商品
ProductQtySet.prototype.listenMinusEvent = function () {
    var submitBtn = $('.dec');
    submitBtn.click(function () {
        var count = $(this).siblings('input').val();
        count = parseInt(count) - 1;
        if(count < 1){
            count = 1;
        }
        $(this).siblings('input').val(count);
    })
}


// 用于对订单数量输入框数据的校验
// blur: 当输入完数据，鼠标在输入框 外面任何地方点一下，就会被监听到
ProductQtySet.prototype.listenCountEvent = function () {
    var countShow = $('.count-show');
    countShow.blur(function () {
        // 获取用户输入数据
        var count = $(this).val();
        //校验数据
        // isNaN(count):如果不能转化为数字就返回：真. trim()：去除空格
        if (isNaN(count) || count.trim().length === 0 || parseInt(count) <= 0) {
            count = 1;
        }else if(parseInt(count) > 10){
            count = 10;
        }
        // parseInt(count): 转成整数
        $(this).val(parseInt(count));
    })

}


ProductQtySet.prototype.run = function () {
    this.listenCountEvent();
    this.listenAddEvent();
    this.listenMinusEvent();
}

$(function () {
    var productQtySet = new ProductQtySet();
    productQtySet.run();
})

